export default {
    setEvents(state, data) {
        state.events = data
    },
    setEvent(state, data) {
        state.event = data
    }
}
